<div class="garageModal-overlay">
  <div class="garageModal-container">

    <div class="garageModal-header">
      <div class="garageModal-title">{{ popOverData?.tripInfo?.tripType === 'segment' ? 'Mid Trip Summary' : 'Trip Summary'}}</div>
      <button class="garageModal-close" aria-label="Close" mat-dialog-close>×</button>
    </div>

    <div class="garageModal-grid white-bg-cont-modal">
      <div class="garageModal-child1">
        <div class="gModal-gBox">
          <div class="gModal-gBox-header">Trip Overview</div>
          <div class="gModal-gBox-row1"><span class="gModal-tripId">Trip ID:</span> <span class="gModal-tripId-v">{{
              popOverData?.tripInfo?.tripId }}</span></div>
          <div class="gModal-gBox-row2"><span class="gModal-tripId">VIN:</span><span class="gModal-tripId-v">{{
              popOverData?.tripInfo?.vehicleId }}</span></div>
          <div>
            <img [src]="popOverData?.tripInfo?.imageUrl || 'assets/images/summary-dummy-truck.png'" alt="vehicle"
              class="img-fluid" />
          </div>
        </div>
      </div>

      <div class="garageModal-child2">
        <div class="garageModal-child2-row">
          <div class="g-modal-loc-header-cont">
            <img src="../../../../assets/images/M-loc.svg" alt="icon" class="img-fluid">
            <span class="g-modal-loc-header">Start Location</span>
          </div>
          <div class="g-modal-c2r2-line2">{{ (popOverData?.tripInfo?.tripType === 'segment' ? segmentStartLocation :popOverData?.tripInfo?.startLocation) ?? '--' }} </div>
          <div class="g-modal-c2r2-line3">{{ popOverData?.tripInfo?.startTime }}</div>
        </div>
        <div class="garageModal-child2-row">
          <div class="g-modal-loc-header-cont">
            <img src="../../../../assets/images/M-flag.svg" alt="icon" class="img-fluid">
            <span class="g-modal-loc-header">End Location</span>
          </div>
          <div class="g-modal-c2r2-line2">{{ (popOverData?.tripInfo?.tripType === 'segment' ? segmentEndLocation : popOverData?.tripInfo?.endLocation) ?? '--' }}</div>
          <div class="g-modal-c2r2-line3">{{ popOverData?.tripInfo?.endTime }}</div>
        </div>
      </div>

      <div class="garageModal-child3">
        <div class="garageModal-row">
          <div class="garageModal-cell">
            <h4>{{ (popOverData?.tripInfo?.distance || popOverData?.tripInfo?.distance === 0) ?
              popOverData?.tripInfo?.distance : '0' }} km</h4>
            <div>Distance</div>
          </div>
          <div class="garageModal-cell">
            <h4>{{
              popOverData?.tripInfo?.duration ? (+popOverData?.tripInfo?.duration | duration)
              : "0 min"
              }}</h4>
            <div>Duration</div>
          </div>
        </div>
        <div class="garageModal-row">
          <div class="garageModal-cell">
            <h4>{{ popOverData?.tripInfo?.totalFuelConsumed }} L</h4>
            <div>Fuel Used</div>
          </div>
          <div class="garageModal-cell">
            <h4>{{ popOverData?.tripInfo?.mileage }} km/L</h4>
            <div>Avg. Mileage</div>
          </div>
        </div>
      </div>
    </div>

    <div class="garageModal-parentGrid">
      <div class="garageModal-parentChild">
        <div class="garageModal-item" *ngFor="let card of statusData.slice(0, 4); trackBy: trackByFn">
          <div class="icon-container _{{card?.id}}">
          </div>
          <h4>{{ card.value || card.value === 0 ? card.value : '0'}}{{ card.unit }}</h4>
          <div class="gModal-item-desc">{{ card.label }}</div>
        </div>
      </div>


      <div class="garageModal-parentChild">
        <div class="garageModal-item" *ngFor="let card of statusData.slice(4, 8); trackBy: trackByFn">
          <div class="icon-container _{{card?.id}}">
          </div>
          <h4>{{ card.value || card.value === 0 ? card.value : '0'}}{{ card.unit }}</h4>
          <div class="gModal-item-desc">{{ card.label }}</div>
        </div>
      </div>
    </div>
    <!--third row-->
    <div class="garageModal-container-row">

      <!-- First column -->
      <div class="garageModal-col1-row ">

        <!-- <div class="garageModal-auto-row">
          <div class="gModal-score">Estimated saving with perfect score</div>
          <div class="gModal-Score-row">
            <div class="gModal-Score-text">11.0 L</div>
            <div class="gModal-Score-capsule">Active</div>
            <div class="gModal-Score-icon">
              <img src="../../../../assets/images/m-MagicWand.svg" alt="icon" class="img-fluid">
            </div>
          </div>

        </div> -->
        <div class="white-bg-cont-modal gModal-trip-scores-segment" [ngClass]="{'gModal-trip-scores': popOverData?.tripInfo?.tripType !== 'segment'}">

          <h4 class="gModal-trip-per">{{ popOverData?.tripInfo?.tripType === 'segment' ? 'Trip Segment Performance' : 'Trip Performance'}}</h4>

          <div class="performance-header-section" *ngIf="popOverData?.tripInfo?.tripType !== 'segment'">
            <div class="score-circle-container">
              <app-doughnut-chart
                *ngIf="tripOptimizationData?.summary?.score || tripOptimizationData?.summary?.score === 0" class="chart"
                [series]="options?.series" [legend]="options?.legend" [graphic]="options?.graphic"
                [grid]="options?.grid"></app-doughnut-chart>

              <div class="score-content"
                *ngIf="!tripOptimizationData?.summary?.score && tripOptimizationData?.summary?.score!==0">
                --
              </div>
            </div>
            <div class="gModal-score-desc">
              {{tripOptimizationData?.summary?.note ?? '--'}}

              <hr class="note-horizontal">
              <div class="gModaldesc-container">
                <div class="gModaldesc-column">
                  <div class="gModaldesc-textSecondary">vs Last Trip</div>
                  <div class="gModaldesc-textPrimary">{{ scoreDiff != null ? (scoreDiff >= 0 ? '+' + scoreDiff : '-' +
                    (scoreDiff * -1)) : '+0.3' }}</div>
                </div>

                <div class="gModaldesc-column disabled">
                  <div class="gModaldesc-textSecondary">Efficiency Gain</div>
                  <div class="gModaldesc-textPrimary">{{ efficiencyGain != null ? (efficiencyGain >= 0 ? '+' +
                    efficiencyGain : '-' + (efficiencyGain * -1)) : '+12' }}%</div>
                </div>
              </div>


            </div>
          </div>
          <div class="score-circle-container" *ngIf="popOverData?.tripInfo?.tripType === 'segment'">
            <app-doughnut-chart *ngIf="tripOptimizationData?.summary?.score || tripOptimizationData?.summary?.score === 0"
              class="chart" [series]="options?.series" [legend]="options?.legend" [graphic]="options?.graphic"
              [grid]="options?.grid"></app-doughnut-chart>
            <div class="score-content"
              *ngIf="!tripOptimizationData?.summary?.score && tripOptimizationData?.summary?.score!==0">
              --
            </div>
          </div>
          <div class="gModal-score-desc height-fc mt-3" *ngIf="tripOptimizationData?.summary?.note && popOverData?.tripInfo?.tripType === 'segment'">
            {{tripOptimizationData?.summary?.note ?? '--'}}
          </div>

          
          <div class="top-score" *ngIf="popOverData?.tripInfo?.tripType !== 'segment'">Top 3 Trip Score</div>
          <div class="gModal-row-container" *ngIf="popOverData?.tripInfo?.tripType !== 'segment'">
            <div class="gModal-row-Scoreboxes-container gModal-greybox" *ngFor="let trip of trips, let i =index"
              [ngClass]="{'gModal-greenbox': trip?.tripId === data?.tile1?.tripId}">
              <div class="gModal-row-Scoreboxes-left">
                <div class="gModal-row-Scoreboxes-box gModal-light-grey"
                  [ngClass]="{'gModal-light-green': trip?.tripId === data?.tile1?.tripId}">
                  #{{ i+1 }}</div>
                <div class="gModal-row-Scoreboxes-box gModal-dark-grey" [matTooltip]="trip?.tripId"
                  [ngClass]="{'gModal-light-green': trip?.tripId === data?.tile1?.tripId}">
                  Trip&nbsp;{{ formatTripId(trip?.tripId) ?? 'Trip '+(i+1) }}
                  <span *ngIf="trip?.tripId === data?.tile1?.tripId">&nbsp;(Current)</span>
                </div>
              </div>

              <div class="gModal-row-Scoreboxes-right gModal-dark-grey"
                [ngClass]="{'gModal-light-green': trip?.tripId === data?.tile1?.tripId}">
                {{ trip?.modelOutput?.summary?.score ?? '--' }}
              </div>
            </div>

            <!--Current trip position-->
            <div
              class="gModal-row-Scoreboxes-container gModal-greenbox" 
              *ngIf="!currentTripIncluded">
              <div class="gModal-row-Scoreboxes-left">
                <div class="gModal-row-Scoreboxes-box gModal-light-green">
                  #{{ currentTripPosition }}</div>
                <div class="gModal-row-Scoreboxes-box gModal-light-green" [matTooltip]="data?.tile1?.tripId">
                  Trip&nbsp;{{ formatTripId(data?.tile1?.tripId) ?? 'Trip ' }}
                  <span>&nbsp;(Current)</span>
                </div>
              </div>
              <div
                class="gModal-row-Scoreboxes-right gModal-light-green">
                {{ tripOptimizationData?.summary?.score ?? '--' }}
              </div>
            </div>
             <!--Current trip position-->
          </div>
        </div>
      </div>

      <!-- Second column -->
      <div class="garageModal-col2-row">

        <div class="gmodal-recomodal-grid">
          <div class="gmodal-recomodal-item gModal-white-boxe"
            [ngClass]="{'gModal-ligt-turqoise': selectedTagIndex === 0}" (click)="onTagSelection(0, 'safety')">
            <div class="gmodal-recomodal-icon"><img src="../../../../assets/images/m-verified_user.svg" alt="icon"
                class="img-fluid">
            </div>
            <div class="gmodal-recomodal-title">{{tripOptimizationData?.summary?.safety || '--'}}</div>
            <div class="gmodal-recomodal-desc">Safety</div>
          </div>

          <div class="gmodal-recomodal-item gModal-white-boxe"
            [ngClass]="{'gModal-ligt-turqoise': selectedTagIndex === 1}" (click)="onTagSelection(1, 'economy')">
            <div class="gmodal-recomodal-icon"><img src="../../../../assets/images/m-eco.svg" alt="icon"
                class="img-fluid"></div>
            <div class="gmodal-recomodal-title">{{tripOptimizationData?.summary?.economy || '--'}}</div>
            <div class="gmodal-recomodal-desc">Economy</div>
          </div>

          <div class="gmodal-recomodal-item gModal-white-boxe"
            [ngClass]="{'gModal-ligt-turqoise': selectedTagIndex === 2}" (click)="onTagSelection(2, 'comfort')">
            <div class="gmodal-recomodal-icon"><img src="../../../../assets/images/m-chair.svg" alt="icon"
                class="img-fluid"></div>
            <div class="gmodal-recomodal-title">{{tripOptimizationData?.summary?.comfort || '--'}}</div>
            <div class="gmodal-recomodal-desc">Comfort</div>
          </div>
        </div>

        <!-- Header -->
        <div *ngIf="tripOptimizationData?.optimizationTips?.length as recCount; else noRecs">
          <div class="gModal-recommendation">
            Recommendations ({{ recCount }})
          </div>

          <div class="reco-detail-cont">
            <div class="gModal-reco-greybox" *ngFor="let trip of tripOptimizationData.optimizationTips">
              <h4 class="gModal-rec-header">
                {{ getOptimizationAttributesName(trip?.attributeName) || (trip?.attributeName | titlecase ) }}
              </h4>
              <div class="gModal-rec-details">{{ trip?.text }}</div>
            </div>
          </div>
        </div>

        <!-- If NO recommendations -->
        <ng-template #noRecs>

          <!-- Case 2: show feedbacks when score==100 -->
          <div *ngIf="optimizationTipFeedback?.length && getScore(selectedTagIndex) == maxScore; else empty">
            <div class="gModal-recommendation">
              Feedbacks ({{ optimizationTipFeedback.length }})
            </div>

            <div class="reco-detail-cont">
              <div class="gModal-reco-greybox" *ngFor="let trip of optimizationTipFeedback">
                <h4 class="gModal-rec-header">
                  {{ getOptimizationFeedbackName(trip?.attributeName) || (trip?.attributeName | titlecase ) }}
                </h4>
                <div class="gModal-rec-details">{{ trip?.text }}</div>
              </div>
            </div>
          </div>

        </ng-template>

        <!-- Case 3: empty state -->
        <ng-template #empty>
          <div class="empty-state">
            <svg class="empty-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="1">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 6v6l4 2"></path>
            </svg>
            <p class="empty-text">No Recommendations/Feedbacks available</p>
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>